import type { FaireProductEntity } from "../../entity_types/product";

export const p_2k85eg5vnk: FaireProductEntity = {
  token: "p_2k85eg5vnk",
  type: "product",
  name: "Frontier Co-op Hibiscus Flowers, Certified Organic",
  brandToken: "b_5ashuqcsm4",
  brandName: "Frontier Co-op",
  imageUrl:
    "https://cdn.faire.com/fastly/935248e800fd8d64eb47d460d73c467e2a1352e056606f2c054f446d08c77893.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d57373887ba6fa0d15f3ce1e8dc21d2b7100c30e5947db76193ee1334bbee17e.jpeg",
    "https://cdn.faire.com/fastly/840ef5ec2065c27b444649560ca35758c58f65a665258092e32763068653611e.jpeg",
    "https://cdn.faire.com/fastly/fd7fb3156e0f6f9cc79f8c77b746bf4ac799a1da9f4fbcb438fcfc0cc37fa1f1.jpeg",
    "https://cdn.faire.com/fastly/780c54c87451aa020dbeba843a238a9d46dc57298fe4759255be05e9563ecbad.jpeg",
  ],
  priceDollars: 8.92,
  description:
    "Frontier Co-op® Organic Hibiscus Flowers (Hibiscus sabdariffa L.) are vibrant, trumpet-shaped flowers grown from shrubs native to warm climates. These caffeine-free flowers are perfect for herbal tea blends, offering a tart, cranberry-like flavor when steeped in hot water. Hibiscus flowers can also enhance green and black teas with their robust taste. Their bold flavor and colorful appearance make them a unique addition to a variety of cuisines. Additionally, hibiscus flowers have been used in cosmetics and as a natural dye.\n\n•\t5.82 oz. \n•\tForm – Cut & Sifted\n•\tBotanical Name – Hibiscus sabdariffa L.\n•\tCertified Organic\n•\tCertified Kosher\n•\tNon-ETO\n•\tNon-Irradiated\n•\tNo Artificial Ingredients",
  tags: [],
  msrpDollars: 13.29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:43.682Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
